import React from 'react';
import { connect } from 'react-redux';
import { makeGetComputedFields } from '../selectors';

import { CSSTransition } from 'react-transition-group';

const CalculatedRowDetails = ({ computedFields, isHovered }) => (
    <CSSTransition 
        in={isHovered} 
        timeout={500}
        classNames="appear"
        unmountOnExit
    >
        <div 
            className='row-calc-details'
        >
            <p> {isNaN(computedFields.numDaysBetweenSentAndPaid) 
                ? 'Date bill sent OR Date of payment field invalid.' 
                : `${computedFields.numDaysBetweenSentAndPaid} days between date bill sent and date paid.`}
            </p>

            <p>{isNaN(computedFields.interestPerDay) || computedFields.interestPerDay === 0
                ? 'Amount paid is invalid.'
                : `$${computedFields.interestPerDay.toFixed(3)} interest per day.`}
            </p>

            <p>{isNaN(computedFields.interestAccruedUntilPayment) || computedFields.interestAccruedUntilPayment === 0
                ? '' // the first 2 invalid displays explain why this field can't be calculated
                : `$${computedFields.interestAccruedUntilPayment.toFixed(2)} accumulated from late payment.`}
            </p>

            <p>{isNaN(computedFields.totalAsOfToday)
                ? ''
                : `$${computedFields.totalAsOfToday.toFixed(2)} accumulated as of today.`}
            </p>

        </div>
    </CSSTransition>
)

const makeMapStateToProps = () => {
    const getComputedFields = makeGetComputedFields();
    const mapStateToProps = (state, props) => {
        return {
            computedFields: getComputedFields(state, props)
        }
    }
    return mapStateToProps;
}

export default connect(
    makeMapStateToProps
)(CalculatedRowDetails);